var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G } from "react-native-svg";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 1C18.8 1 24 6.2 24 12.5S18.8 24 12.5 24 1 18.8 1 12.5 6.2 1 12.5 1m0-1C5.6 0 0 5.6 0 12.5S5.6 25 12.5 25 25 19.4 25 12.5 19.4 0 12.5 0z",
    fill: "#e1087e"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M6.1 11.9h13v1h-13zM6.1 16.3h13v1h-13zM6.1 7.6h13v1h-13z"
  }))));
}
export default SvgMenu;